module.exports = __webpack_public_path__ + "img/desktop_person2.99d7cd37.svg";